import React, { RefObject } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { CIRCLE_LOGO } from 'src/components/pages/PartnersPage/constants';

import styles from './Toast.scss';

const Toast = ({ targetRef }: { targetRef: RefObject<HTMLDivElement> }) => {
  const { isMobile } = useLayoutContext();

  const scrollButtonClick = () => {
    targetRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  if (isMobile) {
    return (
      <button className={styles.button} onClick={scrollButtonClick}>
        Schedule a demo
      </button>
    );
  }

  return (
    <div className={styles.toastContainer}>
      <img className={styles.logo} src={CIRCLE_LOGO} alt="" />
      <p className={styles.text}>
        Discover more about
        <br />
        Travel Loyalty Solutions
      </p>
      <button className={styles.button} onClick={scrollButtonClick}>
        Schedule a demo
      </button>
    </div>
  );
};

export default Toast;
